import { render, staticRenderFns } from "./IconSearchModal.vue?vue&type=template&id=b24e50cc&scoped=true&"
import script from "./IconSearchModal.vue?vue&type=script&lang=js&"
export * from "./IconSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./IconSearchModal.vue?vue&type=style&index=0&id=b24e50cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e50cc",
  null
  
)

export default component.exports